<template>
  <div class="about-content flex row-between">
    <div class="about-left">
      <div class="item-title">
        途陽国際株式会社
      </div>
      <div class="item-desc">メールボックス:<span>toyoukokusai.tokyo@gmail.com</span></div>
      <div class="item-desc">電話番号:<span>03-5825-4774</span></div>
      <div class="item-desc">
        会社住所:<span>東京都台東区浅草橋1丁月9-12VORT浅草駅前Ⅱ6F代表者:望月辉石</span>
      </div>
    </div>
    <div class="about-right">
      <img class="code" :src="imgUrl + 'line-qrcode.png'" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Relation',
  data() {
    return {
      imgUrl: process.env.VUE_APP_FILE_URL
    }
  }
}
</script>
<style scoped lang="scss">
.about-content {
  padding: 69px 46px 46px;
  .item-title {
    color: #14141e;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 1.2px;
    margin-bottom: 22px;
    @media (max-width: $mobile-breakpoint) {
      font-size: 20px;
    }
  }
  .item-desc {
    color: #14141e;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 16px;
    @media (max-width: $mobile-breakpoint) {
      font-size: 12px;
    }
  }
  .code {
    width: 154px;
    @media (max-width: $mobile-breakpoint) {
      width: 138px;
    }
  }
}
</style>
